import { ITableColumn } from "src/app/common/components/table/interfaces/table-column";
import { RegionCellComponent } from "../../cells/region-cell.component";

export const municipalitiesTableConfig: { columns: Array<ITableColumn>; nestedColumns: Array<ITableColumn> } = {
  columns: [
    {
      id: "regionName",
      type: "custom",
      key: "USER_SETTINGS.MUNICIPALITY",
      style: {
        width: "30%"
      },
      customTemplate: RegionCellComponent
    },
    {
      id: "internal",
      type: "text",
      key: "USER_SETTINGS.LIST_USERS.INTERNAL",
      style: {
        width: "30%"
      }
    },
    {
      id: "external",
      type: "text",
      key: "USER_SETTINGS.LIST_USERS.EXTERNAL",
      style: {
        width: "30%"
      }
    },
    {
      id: "expand",
      type: "action",
      actionIcon: "ec_networks_mix_addrow",
      selectedIcon: "ec_networks_mix_deleterow",
      key: "",
      style: {
        "text-align": "center"
      }
    }
  ],
  nestedColumns: [
    {
      id: "name",
      type: "text",
      key: "USER_SETTINGS.NAME",
      style: {
        width: "22%"
      }
    },
    {
      id: "email",
      type: "text",
      key: "USER_SETTINGS.LIST_USERS.EMAIL",
      style: {
        width: "22%"
      }
    },
    {
      id: "emailConfig",
      type: "notification-settings",
      key: "USER_SETTINGS.LIST_USERS.EMAIL_CONFIG",
      style: {
        width: "14%"
      }
    }
  ]
};
